export type ViewportBand = 'mobile' | 'tablet' | 'desktop';

export function getViewportBand(viewport: { w: number; h: number }): ViewportBand {
  if (viewport.w < 768) return 'mobile';
  if (viewport.w < 1280) return 'tablet';
  return 'desktop';
}

function isPortrait(viewport: { w: number; h: number }): boolean {
  return viewport.h >= viewport.w;
}

export function shouldRefreshFingerprintForViewport(
  previous: { w: number; h: number } | null,
  next: { w: number; h: number },
): boolean {
  if (!previous) return true;
  return getViewportBand(previous) !== getViewportBand(next)
    || isPortrait(previous) !== isPortrait(next);
}
